<ng-container *ngIf="_isLiftBanAction; else banBlock">
    <p-dialog [(visible)]="displayModalBanned" [modal]="true" [style]="{width: '500px'}"
              [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false"
              [closeOnEscape]="false" styleClass="ban-customer-modal">
        <div class="flex flex-column" style="padding: 10px;">
            <h3 class="text-xl font-bold text-color m-0 mb-2">Lift Ban</h3>
            <p class="text-sm text-color-secondary line-height-3 m-0 mb-3">
                This will restore the account to Active.
            </p>
            <p class="font-semibold text-color m-0 mb-4">{{userName}} &bull; {{userId}}</p>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Select Reason:</label>
                <p-dropdown [options]="liftBanReasonOptions"
                            [(ngModel)]="selectedLiftReason"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Reason"
                            styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Notes (optional)</label>
                <textarea rows="3" pInputTextarea [(ngModel)]="liftBanNotes"
                          placeholder="Add internal notes that explain the context"
                          class="w-full"></textarea>
            </div>

            <div class="flex justify-content-center gap-3 mt-2 pt-2">
                <button pButton type="button" label="Cancel"
                        class="p-button-outlined p-button-secondary"
                        (click)="cancel()"></button>
                <button pButton type="button" label="Lift Ban"
                        class="btn-teal"
                        [disabled]="!isLiftFormValid()"
                        (click)="liftBanUser()"></button>
            </div>
        </div>
    </p-dialog>
</ng-container>
<ng-template #banBlock>
    <p-dialog [(visible)]="displayModalBanned" [modal]="true" [style]="{width: '500px'}"
              [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false"
              [closeOnEscape]="false" styleClass="ban-customer-modal">
        <div class="flex flex-column" style="padding: 10px;">
            <h3 class="text-xl font-bold text-color m-0 mb-2">Ban Customer</h3>
            <p class="text-sm text-color-secondary line-height-3 m-0 mb-3">
                Specify the reason for banning this account.
            </p>
            <p class="font-semibold text-color m-0 mb-4">{{userName}} &bull; {{userId}}</p>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Select Reason:</label>
                <p-dropdown [options]="reasonOptions"
                            [(ngModel)]="selectedReason"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Reason"
                            styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Notes (optional)</label>
                <textarea rows="3" pInputTextarea [(ngModel)]="bannedNotes"
                          placeholder="Add internal notes that explain the context"
                          class="w-full"></textarea>
            </div>

            <div class="flex justify-content-center gap-3 mt-2 pt-2">
                <button pButton type="button" label="Cancel"
                        class="p-button-outlined p-button-secondary"
                        (click)="cancel()"></button>
                <button pButton type="button" label="Confirm Ban"
                        class="p-button-danger"
                        [disabled]="!isFormValid()"
                        (click)="bannedUser()"></button>
            </div>
        </div>
    </p-dialog>
</ng-template>

<p-toast></p-toast>
